import { PaginableRequest, SortDir } from 'src/services/redux/api';
import { Firm } from '../firm';

export interface CollectionState {
  deletedCollections: Record<number, boolean>;
}

export enum SortField {
    NAME = 'name',
    DISPLAY_NAME = 'displayName',
}

export interface Collection {
  firms: Firm[];
  id: number;
  name: string;
  displayName: string;
  description?: string;
  timestamp: string;
  itemsCount?: number;
  collectionItems?: CollectionItem[];
  largePreview?: any;
  smallPreview?: any;
}

export interface CollectionItemSlim {
  id: number;
  order: number;
  altDescription?: string;
  video: {
    id: number;
    title: string;
    description: string;
    smallPreview?: { id: number; url: string; type: string; key: string; directory?: string };
  };
}

export interface Preview {
    id: number;
    url: string;
    type: string;
    key: string;
    directory?: string;
}

export interface CollectionItem {
  id: number;
  altDescription?: string;
  video: {
    id: number;
    title: string;
    description: string;
    url: string;
    timestamp: string;
    smallPreview?: Preview;
    largePreview?: Preview;
    isFavourite: boolean;
  };
  order: number;
}

export type CollectionListRequest = PaginableRequest & {
  firmId?: number;
  search?: string;
  sortBy?: SortField;
  sortDir?: SortDir;
};

export interface CollectionItemsRequest extends PaginableRequest {
  id: number;
}

export interface CreateCollection {
  name: string;
  displayName: string;
  description?: string;
  firmIds?: number[];
}

export interface UpdateCollection {
  name?: string;
  displayName?: string;
  description?: string;
  firmIds?: number[];
}

export interface AddCollectionItem {
  collectionId: number;
  videoIds: number[];
}

export interface DeleteCollectionItem {
  collectionId: number;
  videoId: number;
}
